/**
 * Service: cartApi
 */
angular.module('acme.common.service.cartApi', [
  'acme.common.factory.apiVersion'
])
.service('CartApiService', [ '$http', 'ApiVersionFactory', function($http, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        //note: This b2c endpoint is temporary. We must use b2b endpoints here.
        this.service = endpoint + '/carts';
        this.item.service = endpoint + '/carts';
        this.checkout.service = endpoint + '/checkout';
        return this;
      },

      list: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({url: this.service, version: 'v2'})
        });
      },

      detail: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({url: this.service, version: 'v2'})
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({url: this.service, version: 'v2'}),
          data: {
            visitorId: props.visitorId,
            tempVisitorId: props.tempVisitorId,
            membershipCategoryId: props.membershipCategoryId,
            couponCodes: props.couponCodes,
            items: props.items,
            forms: props.forms,
            comboItems: props.comboItems,
            membershipIds: props.membershipIds,
            saleChannel:"insideSalesIndividual",
            verifyEntitlements: props.verifyEntitlements
            // Properties below are deprecated
            // couponCode: props.couponCode,
            // membershipId: props.membershipId
          }
        });
      },

      validateCoupons: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/couponcode/validate', version: 'v2' }),
          data: {
            shoppingCartId: props.shoppingCartId,
            couponCodes: props.couponCodes
          }
        });
      },

      update: function(props) {
        var av = new ApiVersionFactory();

        props = props || {};
        props.saleChannel = "insideSalesIndividual";

        return $http({
          method: 'put',
          url: av.init({url: this.service + '/' + props.id, version: 'v2'}),
          data: props
        });
      },

      delete: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({url: this.service + '/' + id, version: 'v2'})
        });
      },

      item: {
        service: '',

        add: function(cartId, props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({url: this.service + '/' + cartId + '/items', version: 'v2'}),
            data: {
              eventId: props.eventId,
              ticketingTypeId: props.ticketingTypeId,
              inventoryId: props.inventoryId,
              quantity: props.quantity,
              itemType: props.itemType,
              addonType: props.addonType, //for donations
              membershipInfo: props.membershipInfo,
              membershipId: props.membershipId, // the membership used to purchase this order item
              couponCodes: props.couponCodes,
              admissionType: props.admissionType,
              range: props.range,
              isRetail: props.isRetail,
              eventName: props.eventName,
              ticketingTypeName: props.ticketingTypeName,
              inventoryName: props.inventoryName,
              unitPrice: props.unitPrice,
              retailUnitPrice: props.retailUnitPrice,
              amount: props.amount,
              discountId: props.discountId,
              donationDetail: props.donationDetail,
              saleChannel: "insideSalesIndividual",
              ignoreEntitlements: props.ignoreEntitlements
        }
          });
        },

        update: function(cartId, props) {
          var av = new ApiVersionFactory();

          props = props || {};
          props.saleChannel = "insideSalesIndividual";

          return $http({
            method: 'put',
            url: av.init({url: this.service + '/' + cartId + '/items/' + props.itemId, version: 'v2'}),
            data: props
          });
        },

        delete: function(cartId, id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({url: this.service + '/' + cartId + '/items/' + id, version: 'v2'})
          });
        }
      },

      checkout: {
        service: '',

        create: function(data) {
          var av = new ApiVersionFactory();
          return $http({
            method: 'post',
            headers: {
              'x-acme-request-uuid': data.requestUUID
            },
            data: data,
            url: av.init({ url: this.service, version: 'v2' })
          });
        }
      }

    };

}]);